import { HStack, Text } from '@chakra-ui/react';
import { CheckCircle, CloseCircle } from '@time-line/components/icons';
import type { ReactNode } from 'react';

interface ItemProps {
  isChecked: boolean;
  children: ReactNode;
}

export function Item({ isChecked, children }: ItemProps) {
  return (
    <HStack
      gap="3xs"
      alignItems="center"
      as="li"
      color={isChecked ? 'gray.600' : 'red.300'}
    >
      {isChecked ? (
        <CheckCircle aria-hidden={false} role="img" aria-label="Included" />
      ) : (
        <CloseCircle aria-hidden={false} role="img" aria-label="Not included" />
      )}
      {typeof children === 'string' ? (
        <Text size="detail">{children}</Text>
      ) : (
        children
      )}
    </HStack>
  );
}
